<template>
  <el-dialog class="user_model_dialog" top="5vh" center title="编辑用户" :append-to-body="true" width="70%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
        <div style="display: flex;">
          <el-form-item  label="中文名" prop="title" :label-width="formLabelWidth" style="width:40%;">
            <el-input v-model="form.nameZh" autocomplete="off" :disabled="isProjectDisabled">
            </el-input>
          </el-form-item>
          <el-form-item  label="英文名" prop="title" :label-width="formLabelWidth" style="width:40%;">
            <el-input v-model="form.nameEn" autocomplete="off" :disabled="isProjectDisabled">
            </el-input>
          </el-form-item>
        </div>
      <div style="display: flex;">
        <el-form-item  label="工号" prop="title" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.empCode" autocomplete="off" :disabled="isProjectDisabled">
          </el-input>
        </el-form-item>
        <el-form-item label="部门" prop="type" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.deptName" autocomplete="off" :disabled="isProjectDisabled">
          </el-input>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="状态" prop="priority" :label-width="formLabelWidth" style="width:40%;">
          <el-switch
              @change="changeSwitch"
              v-model="form.status"
              active-color="#11a983"
              inactive-color="#f5f7fa"
              active-value="1"
              inactive-value="0">
          </el-switch>

        </el-form-item>
        <el-form-item label="创建时间" prop="planFinishDate" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.createTime" autocomplete="off" :disabled="isProjectDisabled">
          </el-input>
        </el-form-item>
      </div>
        <el-form-item  label="邮箱" prop="email" :label-width="formLabelWidth" style="width:80%">
          <el-input v-model="form.email" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds" :label-width="formLabelWidth">
          <el-select size="mini"  v-model="form.roleIds"
                      multiple filterable placeholder="请选择角色" style="width: 76.5%">
            <el-option v-for="(item, index) in allRoles" :key="index" :label="item"
                       :value="index" ></el-option>
          </el-select>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button :loading="loading.submit" type="primary"  @click="onSubmit">保存</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  getDevOpsSpaceUserDetailApi,
  getDevOpsSpaceUserRoleListApi,
  postDevOpsSpaceUpdateUserApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        roleIds: [],
        email: '',
      },
      rules: {
        email: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        roleIds: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
      },
      allRoles: [],
    };
  },
  async mounted() {
    const { id = '',nameZh, nameEn,empCode,deptName,role,status,statusDesc,email} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id,nameZh, nameEn,empCode,deptName,role,status,statusDesc,email}
    this.$set(this.form, 'username', username)
    this.username = username;
    await this.getUserRoleList();
    await this.init(id)
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    // 部分不可编辑
    isProjectDisabled() {
      return true;
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeSwitch(v){
      console.log(v);
    },
    async getUserRoleList(){
      let arr = {};
       await  getDevOpsSpaceUserRoleListApi().then((ret)=>{
         ret.data.forEach((item)=>{
           arr[item.id] = item.name;
         })
       })
      this.allRoles = arr;
    },
    // 获取详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceUserDetailApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          status: info.status.toString(),
          roleIds: info.roleIds ? info.roleIds.split(',') : [],
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    // 调用提交接口
    async moduleSubmit(close = true){
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.form.creator = username;
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          id = "",
          status = "",
          email = "",
          roleIds = "",
        } = this.form;
        const params = { id, status: Number(status), email, roleIds:roleIds.toString()};
        // id 存在 更新 不存在 创建
        const ret =  await postDevOpsSpaceUpdateUserApi(params);
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '编辑成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose();
            }, 500)
          }
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.user_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
